/** Import Sass */
import '../../scss/cirrus.scss';
import '../../scss/core.scss';
import '../../scss/dashboard.scss';

module.hot?.accept();
